import { render, staticRenderFns } from "./ErrorBanner.vue?vue&type=template&id=f794374e&scoped=true"
import script from "./ErrorBanner.vue?vue&type=script&lang=js"
export * from "./ErrorBanner.vue?vue&type=script&lang=js"
import style0 from "./ErrorBanner.vue?vue&type=style&index=0&id=f794374e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f794374e",
  null
  
)

export default component.exports